/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { LoginAttemptGenericApiResponseFromJSON, StringLoginAttemptDictionaryGenericApiResponseFromJSON, } from '../models';
/**
 *
 */
export class MaintenanceApi extends runtime.BaseAPI {
    /**
     */
    apiMaintenanceLoginfailsGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Maintenance/loginfails`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => StringLoginAttemptDictionaryGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiMaintenanceLoginfailsGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiMaintenanceLoginfailsGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    apiMaintenanceUnblockuserGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.username !== undefined) {
                queryParameters['username'] = requestParameters.username;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/Maintenance/unblockuser`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => LoginAttemptGenericApiResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    apiMaintenanceUnblockuserGet(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.apiMaintenanceUnblockuserGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
